import React from "react";
import logo from "../../assets/logo/logo.jpeg";
import { Settings, LogOut } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth, db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { useState, useEffect } from "react";

const Sidebar = () => {
  const navigate = useNavigate();
  const [role, setRole] = useState<string | null>(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const docRef = doc(db, "users", user.uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          if (data.role) {
            setRole(data.role);
          }
        }
      }
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth); // Firebase logout
      localStorage.removeItem("authToken");
      sessionStorage.removeItem("authToken");

      // Redirect and replace history to prevent going back
      navigate("/", { replace: true });
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <aside>
      <div className="flex flex-col justify-between w-36 text-sm shadow-black shadow-md sticky top-0 h-screen p-6">
        <div>
          <div className="flex justify-center items-center mb-10">
            <img src={logo} alt="Logo" className="w-14 h-14" />
          </div>

          <div className="flex flex-col gap-4">
            <Link
              to="/dashboard"
              className="flex items-center gap-2 hover:text-blue-600 hover:fill-blue-600 cursor-pointer"
            >
              Dashboard
            </Link>

            {/* Content Editor no access */}
            {role && role !== "content editor" && (
              <Link
                to="/leads"
                className="flex items-center gap-2 hover:text-blue-600 hover:fill-blue-600 cursor-pointer"
              >
                Leads
              </Link>
            )}

            {role && role !== "content editor" && (
              <Link
                to="/uec2026"
                className="flex items-center gap-2 hover:text-blue-600 hover:fill-blue-600 cursor-pointer"
              >
                UEC 2026
              </Link>
            )}

            {role && role !== "content editor" && (
              <Link
                to="/spm2026"
                className="flex items-center gap-2 hover:text-blue-600 hover:fill-blue-600 cursor-pointer"
              >
                SPM 2026
              </Link>
            )}

            {role &&
              role !== "sales" &&
              role !== "part-time sales" &&
              role !== "Branch Manager" && (
                <Link
                  to="university-listing"
                  className="flex items-center gap-2 hover:text-blue-600 hover:fill-blue-600 cursor-pointer"
                >
                  University Listing
                </Link>
              )}

            {role &&
              role !== "sales" &&
              role !== "part-time sales" &&
              role !== "Branch Manager" && (
                <Link
                  to="course-listing"
                  className="flex items-center gap-2 hover:text-blue-600 hover:fill-blue-600 cursor-pointer"
                >
                  Course Listing
                </Link>
              )}
            {role &&
              role !== "sales" &&
              role !== "part-time sales" &&
              role !== "Branch Manager" && (
                <Link
                  to="scholarship-listing"
                  className="flex items-center gap-2 hover:text-blue-600 hover:fill-blue-600 cursor-pointer"
                >
                  Scholarship Listing
                </Link>
              )}

            {/* Job Application Listing  */}
            {role && (role == "super admin" || role == "admin") && (
              <Link
                to="job-application-listing"
                className="flex items-center gap-2 hover:text-blue-600 hover:fill-blue-600 cursor-pointer"
              >
                Job Application
              </Link>
            )}

            {role && (role == "super admin" || role == "admin") && (
              <Link
                to="user-listing"
                className="flex items-center gap-2 hover:text-blue-600 hover:fill-blue-600 cursor-pointer"
              >
                Users
              </Link>
            )}

            {role && (role == "super admin" || role == "admin") && (
              <Link
                to="/manual-reset-password"
                className="flex items-center gap-2 hover:text-blue-600 hover:fill-blue-600 cursor-pointer"
              >
                Reset Password
              </Link>
            )}
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <div className="flex flex-col gap-4">
            <button
              className="flex items-center gap-2 text-red-600 cursor-pointer"
              onClick={handleLogout}
            >
              <LogOut />
              <p>Logout</p>
            </button>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
